// extracted by mini-css-extract-plugin
export default {"container":"AlarmArea_container__dnFjz","left":"AlarmArea_left__tD5TZ","right":"AlarmArea_right__I8pBX"};